// extracted by mini-css-extract-plugin
export default {"ViewTitle-default":"theme-default_ViewTitle-default__hT7yB"};